import { configureStore } from '@reduxjs/toolkit';
import tradePartnerKYCSlice from '../slices/tradePartnerKYCSlice';
import customerKYCSlice from '../slices/customerKYCSlice';
import riskReducer from '../slices/RiskSlices';
import tradeDescriptionReducer from '../slices/tradeDescriptionSlice';
import factoringSetupReducer from '../slices/factoringSetupSlice';
import termsheetPricingReducer from '../slices/termsheetPricingSlice';
import termsheetStatusReducer from '../slices/termsheetStatusSlice';
import termsheetReducer from '../slices/termsheetSlice';
import setupReducer from '../slices/SetupSlice';
import userSetupReducer from '../slices/userSetupSlice';
import companySetupReducer from '../slices/companySetupSlice';
import authReducer from '../slices/authSlice';
import userManagementReducer from '../slices/userManagementSlice';
import validationReducer from '../slices/validationSlice';
import portfolioReducer from '../slices/portfolioSlice';

const store = configureStore({
  reducer: {
    tradePartnerKYC: tradePartnerKYCSlice,
    customerKYC: customerKYCSlice,
    risk: riskReducer,
    tradeDescription: tradeDescriptionReducer,
    factoringSetup: factoringSetupReducer,
    termsheetPricing: termsheetPricingReducer,
    termsheetStatus: termsheetStatusReducer,
    termsheet: termsheetReducer,
    setup: setupReducer,
    userSetup: userSetupReducer,
    companySetup: companySetupReducer,
    auth: authReducer,
    userManagement: userManagementReducer,
    validation: validationReducer,
    portfolio: portfolioReducer,
  },
});

export default store;